import { Injectable } from '@angular/core';

export interface GadgetsRpc {
  register(name: string, handler: (...args: any[]) => void): void;
  call(...args: any[]): void;
  removeReceiver(frameName: string): void;
  setupReceiver(frameName: string): void;
}

export interface GadgetsGlobal {
  rpc: GadgetsRpc;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class GadgetsApiService {
  get gadgets(): GadgetsGlobal | undefined {
    return (window as Window & { gadgets?: GadgetsGlobal }).gadgets;
  }
}
